export default function SharedProgressBar({ percent = 0, label = "Portfolio progress" }) {
  const value = Math.max(0, Math.min(100, Number(percent) || 0));

  return (
    <div className="shared-progress">
      <div className="shared-progress-meta">
        <span>{label}</span>
        <span>{value}%</span>
      </div>
      <div
        className="shared-progress-bar"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label={label}
      >
        <div className="shared-progress-fill" style={{ width: `${value}%` }} />
      </div>
    </div>
  );
}
